export function getTranslationsPage8(newApplicationFee, localizedStrings) {
  newApplicationFee.usb_couponcode.elementConfig.label =
    localizedStrings.applicationpage.entercouponcode;
  newApplicationFee.applicationOptions.elementConfig.options =
    newApplicationFee.applicationOptions.elementConfig.options.map((option) => {
      if (option.value === "Fee") {
        return {
          ...option,
          label: `${localizedStrings.applicationpage.paytheapplicationfee}`,
        };
      } else if (option.value === "Coupon") {
        return {
          ...option,
          label: localizedStrings.applicationpage.useacouponcode,
        };
      }
      return option;
    });
  return newApplicationFee;
}
